export default __webpack_public_path__ + "static/media/Ballroll_00178.c3e1d334.png";